<template>
  <div class="boostNew__item boostNew__item-show">
    <div class="boostNew__heading" :aria-expanded="show" @click="toggleExpanded()">
        <div class="boostNew__name">{{ name }}</div>
        <span class="boostNew__icon" :aria-hidden="!show">
            <i></i>
            <i></i>
        </span>
      <transition name="fade">
        <div class="boostNew__content" v-show="show">
            <div class="boostNew__text">{{ content }}</div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingBoostItem',
  props: [
    'name',
    'content',
    'show'
  ],
  emits: [
    'toggleExpand'
  ],
  data () {
    return {
      expanded: false,
      hidden: true,
      timer: null
    }
  },
  methods: {
    toggleExpanded () {
      this.$emit('toggleExpand')
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    opacity: 1;
    max-height: 100%;
    transition: opacity all 100ms linear, max-height 100ms linear;
    will-change: opacity, max-height;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 30ms linear, max-height 100ms linear;
    will-change: opacity, max-height;
  }
  .boostNew__item-show{
    transition: all 100ms linear;
  }
</style>
